module.exports = __webpack_public_path__ + "img/expired_certificate.5fa418a7.svg";